
import { make } from 'vuex-pathify';

const state = () => {
  return {
    activeIndex: 0,
    items: [],
    title: null,
    visible: false
  }
};

const actions = {
  setItems ({ commit, items }) {
    commit('SET_ITEMS', items);
  },
  setTitle ({ commit, title }) {
    commit('SET_TITLE', title);
  },
  showGallery ({ commit }, { items, index, title }) {
    if (items !== undefined) {
      commit('SET_ITEMS', items);
    }
    if (index !== undefined) {
      commit('SET_ACTIVE_INDEX', index);
    }
    if (title !== undefined) {
      commit('SET_TITLE', title);
    }
    commit('SET_VISIBLE', true);
  },
};

const getters = {
  ...make.getters(state)
};

const mutations = {
  ...make.mutations(state),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};

